import Header from "./components/Header";
import HeroSection from "./components/Sections/HeroSection";
import AboutUs from "./components/Sections/About";
import OurPartners from "./components/Sections/OurPartners";
import Testimonials from "./components/Sections/Testimonials";
import ContactUs from "./components/Sections/ContactUs";
import Footer from "./components/Footer";
import Copyright from "./components/Copyright";
import OurOfferings from "./components/Sections/OurOfferings";
import WhyUs from "./components/Sections/WhyUs";


function App() {
  return (
    <>
      <Header/>
      <HeroSection/>
      <AboutUs/>
      <OurOfferings/>
      <WhyUs/>
      <OurPartners/>
      <Testimonials/>
      <ContactUs/>
      <Footer/>
      <Copyright/>
    </>
  );
}

export default App;
